import styled, { createGlobalStyle, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`

const c = {
  bg: '#0a0c0f', bg2: '#111318', bg3: '#181c23', bg4: '#1e2330',
  bdr: '#1f2430', bdr2: '#2a3040',
  acc: '#00e5a0', acc2: '#00b87a',
  txt: '#e8ecf0', txt2: '#8a95a3', txt3: '#5a6370',
  warn: '#f59e0b', danger: '#ef4444',
  mono: "'Space Mono',monospace", sans: "'DM Sans',sans-serif",
}

export const GlobalRomaneioStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap');
`

export const PageWrap = styled.div`
  background:${c.bg}; color:${c.txt}; font-family:${c.sans};
  height:100vh; display:flex; flex-direction:column; overflow:hidden;
`

export const Topbar = styled.div`
  background:${c.bg2}; border-bottom:1px solid ${c.bdr};
  padding:10px 16px; height:48px;
  display:flex; align-items:center; gap:14px; flex-shrink:0;
  h2 { font-size:13px; font-weight:600; color:${c.txt}; }
  .crumb { font-size:11px; color:${c.txt3}; }
`

export const Body = styled.div`flex:1; display:flex; flex-direction:column; min-height:0;`

export const Toolbar = styled.div`
  display:flex; align-items:center; gap:12px; padding:14px 20px;
  background:${c.bg2}; border-bottom:1px solid ${c.bdr}; flex-shrink:0;
  flex-wrap:wrap;
`

export const Field = styled.label`
  display:flex; flex-direction:column; gap:4px;
  font-size:10px; color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em;
`
export const DateInput = styled.input`
  background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:8px 12px; font-size:12px; font-family:${c.sans}; outline:none;
  color-scheme:dark;
  &:focus { border-color:${c.acc}; }
`
export const Select = styled.select`
  min-width:240px; background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:8px 12px; font-size:12px; font-family:${c.sans}; outline:none;
  cursor:pointer;
  &:focus { border-color:${c.acc}; }
  option { background:${c.bg2}; color:${c.txt}; }
`

export const Stats = styled.div`
  display:flex; gap:14px; align-items:center; font-size:11px; color:${c.txt3};
  margin-left:auto;
  strong {
    color:${c.acc}; font-family:${c.mono}; font-size:14px;
    font-weight:700; margin-right:4px;
  }
`
export const RefreshBtn = styled.button`
  background:${c.bg3}; border:1px solid ${c.bdr2}; color:${c.txt2};
  padding:8px 12px; border-radius:7px; font-size:11px; cursor:pointer;
  transition:.15s; font-family:${c.sans};
  &:hover { border-color:${c.acc}; color:${c.acc}; }
  &:disabled { opacity:.5; cursor:not-allowed; }
`
export const PrintBtn = styled.button`
  background:${c.acc}; border:none; color:#000;
  padding:9px 16px; border-radius:8px; cursor:pointer;
  font-size:12px; font-weight:700; font-family:${c.sans};
  transition:.15s; display:inline-flex; align-items:center; gap:6px;
  &:hover { filter:brightness(1.1); }
  &:disabled { opacity:.5; cursor:not-allowed; }
`

export const Content = styled.div`
  flex:1; overflow:auto; padding:20px 20px 48px;
  &::-webkit-scrollbar { width:6px; height:6px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:3px; }
`

export const DriverCard = styled.div`
  background:${c.bg2}; border:1px solid ${c.bdr}; border-radius:12px;
  margin-bottom:18px; overflow:hidden; animation:${fadeIn} .2s ease;
`
export const CardHead = styled.div`
  display:flex; align-items:center; gap:16px; padding:14px 18px;
  border-bottom:1px solid ${c.bdr}; flex-wrap:wrap;
  cursor:pointer; user-select:none; transition:background .12s;
  &:hover { background:${c.bg3}; }
  .chevron {
    width:24px; height:24px; border-radius:6px; flex-shrink:0;
    display:inline-flex; align-items:center; justify-content:center;
    font-size:16px; font-weight:700; background:${c.bg3}; color:${c.acc};
  }
  .who { display:flex; flex-direction:column; gap:2px; }
  .who .name { font-size:15px; font-weight:700; color:${c.txt}; }
  .print { margin-left:auto; }
`
export const Kpis = styled.div`
  display:flex; gap:22px;
  .kpi span { display:block; font-size:10px; text-transform:uppercase; letter-spacing:.05em; color:${c.txt3}; }
  .kpi strong { font-size:16px; color:${c.acc}; font-family:${c.mono}; }
`

export const Table = styled.div`
  display:table; width:100%; border-collapse:collapse;
`
export const THead = styled.div`display:table-header-group; background:${c.bg3};`
export const HRow = styled.div`
  display:table-row;
  & > div {
    display:table-cell; padding:10px 14px; font-size:10px;
    color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em;
    font-weight:600; border-bottom:1px solid ${c.bdr};
  }
  & > div.c { text-align:center; }
  & > div.r { text-align:right; }
`
export const Row = styled.div`
  display:table-row;
  &:hover { background:${c.bg3}; }
  & > div {
    display:table-cell; padding:11px 14px; font-size:12px;
    color:${c.txt}; vertical-align:middle; border-bottom:1px solid ${c.bdr};
  }
  & > div.c { text-align:center; }
  & > div.r { text-align:right; }
  & > div.mono { font-family:${c.mono}; font-size:11px; color:${c.txt2}; }
  &:last-child > div { border-bottom:none; }
`

export const Empty = styled.div`
  text-align:center; padding:50px 20px; color:${c.txt3}; font-size:13px;
  background:${c.bg2}; border:1px dashed ${c.bdr2}; border-radius:10px;
  strong { color:${c.acc}; }
`
export const Loading = styled.div`
  text-align:center; padding:40px 20px; color:${c.txt3}; font-size:12px;
`
